import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import InlineAlert from '../../inline-alert';
import FormInputAddon from '../internals/form-addon';
import FormErrors from './form-errors';
import FormField from './form-field';
import FormHint from './form-hint';
import FormLabel, { type LabelTooltipProps } from './form-label';
export type FormWrapperProps = {
  id?: string;
  error?: string;
  label?: string | React.ReactNode;
  errorPosition: 'absolute' | 'relative';
  addon?: React.ReactNode;
  size: 'default' | 'compact' | 'tiny';
  hint?: string | React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
  orientation?: 'vertical' | 'horizontal' | 'horizontal-justify-between';
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  tooltip?: LabelTooltipProps;
  errorComponent?: 'inlineAlert' | 'text';
  hideError?: boolean;
};
export default function FormWrapper(t0) {
  const $ = _c(64);
  const {
    id,
    error,
    label,
    errorPosition,
    addon,
    size,
    hint,
    orientation,
    children,
    className,
    fullWidth,
    disabled,
    tooltip,
    errorComponent: t1,
    hideError: t2
  } = t0;
  const errorComponent = t1 === undefined ? "text" : t1;
  const hideError = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== error || $[1] !== errorComponent || $[2] !== errorPosition || $[3] !== hideError) {
    t3 = () => {
      if (!error || hideError) {
        return null;
      }
      if (errorComponent === "text") {
        return <FormErrors className={cx({
          "absolute -bottom-6": errorPosition === "absolute"
        })}>{error}</FormErrors>;
      }
      return <InlineAlert variant="error">{error}</InlineAlert>;
    };
    $[0] = error;
    $[1] = errorComponent;
    $[2] = errorPosition;
    $[3] = hideError;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const renderError = t3;
  const isHorizontal = orientation === "horizontal" || orientation === "horizontal-justify-between";
  if (isHorizontal) {
    let t4;
    if ($[5] !== className) {
      t4 = cx("flex flex-col gap-2 text-end", className);
      $[5] = className;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== error || $[8] !== id || $[9] !== label || $[10] !== size || $[11] !== tooltip) {
      t5 = label && <FormLabel hasError={!!error} htmlFor={id} size={size} tooltip={tooltip}>{label}</FormLabel>;
      $[7] = error;
      $[8] = id;
      $[9] = label;
      $[10] = size;
      $[11] = tooltip;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    const t6 = orientation === "horizontal-justify-between";
    let t7;
    if ($[13] !== t6) {
      t7 = cx("flex", {
        "flex-1 justify-end": t6
      });
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== addon || $[16] !== disabled || $[17] !== size) {
      t8 = addon && <FormInputAddon size={size} disabled={disabled}>{addon}</FormInputAddon>;
      $[15] = addon;
      $[16] = disabled;
      $[17] = size;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    let t9;
    if ($[19] !== children || $[20] !== t7 || $[21] !== t8) {
      t9 = <div className={t7}>{t8}{children}</div>;
      $[19] = children;
      $[20] = t7;
      $[21] = t8;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    let t10;
    if ($[23] !== fullWidth || $[24] !== orientation || $[25] !== t5 || $[26] !== t9) {
      t10 = <FormField variant={orientation} fullWidth={fullWidth}>{t5}{t9}</FormField>;
      $[23] = fullWidth;
      $[24] = orientation;
      $[25] = t5;
      $[26] = t9;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    if ($[28] !== renderError) {
      t11 = renderError();
      $[28] = renderError;
      $[29] = t11;
    } else {
      t11 = $[29];
    }
    let t12;
    if ($[30] !== error || $[31] !== hint) {
      t12 = !error && hint && <FormHint>{hint}</FormHint>;
      $[30] = error;
      $[31] = hint;
      $[32] = t12;
    } else {
      t12 = $[32];
    }
    let t13;
    if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t4) {
      t13 = <div className={t4}>{t10}{t11}{t12}</div>;
      $[33] = t10;
      $[34] = t11;
      $[35] = t12;
      $[36] = t4;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    return t13;
  }
  let t4;
  if ($[38] !== error || $[39] !== id || $[40] !== label || $[41] !== size || $[42] !== tooltip) {
    t4 = label && <FormLabel hasError={!!error} htmlFor={id} size={size} tooltip={tooltip}>{label}</FormLabel>;
    $[38] = error;
    $[39] = id;
    $[40] = label;
    $[41] = size;
    $[42] = tooltip;
    $[43] = t4;
  } else {
    t4 = $[43];
  }
  let t5;
  if ($[44] !== addon || $[45] !== children || $[46] !== disabled || $[47] !== size) {
    t5 = addon ? <div className="flex flex-1"><FormInputAddon size={size} disabled={disabled}>{addon}</FormInputAddon><div className="flex flex-1 flex-col">{children}</div></div> : children;
    $[44] = addon;
    $[45] = children;
    $[46] = disabled;
    $[47] = size;
    $[48] = t5;
  } else {
    t5 = $[48];
  }
  let t6;
  if ($[49] !== renderError) {
    t6 = renderError();
    $[49] = renderError;
    $[50] = t6;
  } else {
    t6 = $[50];
  }
  let t7;
  if ($[51] !== error || $[52] !== hint) {
    t7 = !error && hint && <FormHint>{hint}</FormHint>;
    $[51] = error;
    $[52] = hint;
    $[53] = t7;
  } else {
    t7 = $[53];
  }
  let t8;
  if ($[54] !== t5 || $[55] !== t6 || $[56] !== t7) {
    t8 = <div className="relative flex flex-1 flex-col gap-2">{t5}{t6}{t7}</div>;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
  } else {
    t8 = $[57];
  }
  let t9;
  if ($[58] !== className || $[59] !== fullWidth || $[60] !== orientation || $[61] !== t4 || $[62] !== t8) {
    t9 = <FormField variant={orientation} className={className} fullWidth={fullWidth}>{t4}{t8}</FormField>;
    $[58] = className;
    $[59] = fullWidth;
    $[60] = orientation;
    $[61] = t4;
    $[62] = t8;
    $[63] = t9;
  } else {
    t9 = $[63];
  }
  return t9;
}